import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.entries.js";
export function getHasFormErrors(fields, createFieldsForEachId, fieldStates) {
  return Object.entries(fields).some(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      key = _ref2[0];
    var fieldState = fieldStates[key];
    var isDynamicField = typeof fieldState === 'function';
    if (createFieldsForEachId) {
      return createFieldsForEachId.some(function (id) {
        return (
          // `isDynamicField` is always true here, just keeping TS happy
          isDynamicField ? Boolean(fieldState(id).error) : false
        );
      });
    } else {
      // `isDynamicField` is always false here, just keeping TS happy
      return isDynamicField ? false : Boolean(fieldState.error);
    }
  });
}